import React from "react";
import PropTypes from "prop-types";
import { SFGridContainer, SFGridItem } from "../grid";
import SFSkeleton from "./index";

const SFSkeletonGrid = ({ count = 12, columns = 12, xs = 12, md = 6, lg = 3, xl = 3, xxl = 2 }) => (
  <SFGridContainer alignItems="stretch" columns={columns}>
    {[...Array(count)].map((i, index) => (
      <SFGridItem key={index} xs={xs} md={md} lg={lg} xl={xl} xxl={xxl}>
        <SFSkeleton />
      </SFGridItem>
    ))}
  </SFGridContainer>
);

SFSkeletonGrid.propTypes = {
  count: PropTypes.number,
  columns: PropTypes.number,
  xs: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  xxl: PropTypes.number,
};
export default SFSkeletonGrid;
